import { useCallback, useEffect, useRef, useState } from "react";
import { AutoComplete, Input, Avatar, Dropdown, message, Badge, Space } from "antd";
import { useNavigate, useLocation, Link } from "react-router-dom";
import type { SelectProps } from "antd/es/select";
import Parser from "html-react-parser";
import { cloneDeep, debounce, delay } from "lodash-es";
import { useSelector, useDispatch } from "react-redux";
import dataJson from "@/../public/data.json";
import api from "@/api";
import { publicPath, loginUrl, toStagingPath, fullScreenScrolling } from "@/utils/base";
import { enableScroll } from "@/utils";

import "./index.less";
import { getServiceVal, removeServiceVal } from "@/utils/cookies";
import { clearLocalStoragePreservingDownloadQuota } from "@/utils/storage";
import { getMessageCount } from "@/api/messageCenter";
import messageDispatchCenter from "@/utils/messageDispatchCenter";
import { getAccountOrderList } from "@/api/expenseCenter";
import { MESSAGE_ON_TYPE, PAY_STATUS } from "@/types/message";
import store from "@/stores";
import { DocsMessageAction } from "@/pages/document/type";
import { docsPrefix } from "@/pages/document";
import { checkDocumentUrl } from "@/utils/common";
import { resolveLoginUrl } from "@/utils/desktopDownloadReport";
import { goLogin } from "@/utils/common";
const tvHeaderPrefix = "tv-header";

const Header = () => {
  const { header, login, avatar_icon, req_err } = dataJson;
  const [authorization, setAuthorization] = useState<string | null>("");
  const [hiddenHeader, setHiddenHeader] = useState<boolean>(false);
  const [headerOpaque, setHeaderOpaque] = useState<boolean>(false); // 头部不透明
  const [options, setOptions] = useState<SelectProps<object>["options"]>([]);
  const [inputWidth, setInputWidth] = useState<number>(250);
  const [open, setOpen] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const AutoCompleteRef = useRef<any>();
  const [dropdownItems, setDropdownItems] = useState<any[]>(header.avatar_dropdown);
  const navigate = useNavigate();
  const location = useLocation();
  const pathArr = location?.pathname?.split("/");
  const isDocs= checkDocumentUrl(location?.pathname);
  const currentName =pathArr.includes('technicalSupport')?'technicalSupport': pathArr[pathArr?.length - 1];
  const [current, setCurrent] = useState(currentName);
  const [isHover, setIsHover] = useState("");
  const [someDomeEnter, setSomeDomeEnter] = useState<boolean>(false);
  

  const dispatch = useDispatch();
  const scrollHeight = useSelector((state: any) => state.scrollHeight);
  const scrollDirection = useSelector((state: any) => state.scrollDirection);
  const scrollDistance = useSelector((state: any) => state.scrollDistance);
  const isClickCauseScroll = useSelector((state: any) => state.isClickCauseScroll);
  const userDataChange = useSelector((state: any) => state.userDataChange);
  const userData = useSelector((state: any) => state.userData);
  const portalAuthorization = useSelector((state: any) => state.portalAuthorization || getServiceVal("Authorization"));

  const [messageCount, setMessageCount] = useState<number>(0);//消息数量
  const [needPaymentOrderCount, setNeedPaymentOrderCount] = useState<number>(0);//待支付订单数量
  const jump_messgae=()=>{
    if(window.location.pathname.includes("/message")) return;
    navigate("/message/list")
  };
  const jumpAccountCenter=()=>{
    if(window.location.pathname.includes("/expense")) return;
    navigate("/expense/overview")
  }
  /**
   * 获取消息数量
   */
  const getMessageInfo=useCallback(()=>{
    console.log("getMessageInfo");
    getMessageCount().then((res) => {
      console.log(res);
      if (res?.code === 200) {
        console.log(res);
        setMessageCount(res?.result?.unRead || 0);
      }
    }).catch((err: any) => {
      console.log(err);
    })

  },[])
  /**
   * 获取待支付订单数量
   */
  const getOrderInfo=useCallback(()=>{
    getAccountOrderList({pageNumber:1,pageSize:1,payStatus:PAY_STATUS.UNPAID}).then((res)=>{
      if(res?.code===200){
        setNeedPaymentOrderCount(res?.result?.total || 0);
      }
    }).catch((err:any)=>{
      console.log(err);
    })
  },[])
  const setDropdown = (userDetail: any) => {
    const dropdownCopy = cloneDeep(header.avatar_dropdown);
    const dropdownItemCopy = dropdownCopy.map((item: any, index: number) => {
      if (!item.key) {
        if (index === 0) {
          return {
            label: (
              <div className="one-line-ellipsis" style={{cursor: 'pointer'}} title={userDetail.userName} onClick={() => navigate('/user-center/user-info')}>
                {userDetail.userName}
              </div>
            ),
          };
        } else {
          return item;
        }
      } else {
        return {
          key: item.key,
          label: (
            <div onClick={() => dropdownClick(item)} className={`${tvHeaderPrefix}-dropdown-label`}>
              {index === 0 ? userDetail.nickName || userDetail.userName : item.label}
            </div>
          ),
        };
      }
    });
    const messageItem = {
      key: "message",
      url:"/message/all",
      label: <div onClick={jump_messgae} className={`${tvHeaderPrefix}-dropdown-label dropdown-label-message`}>
        <div style={{wordBreak: "keep-all"}}>消息中心</div>
          <div className="message-right">
              {messageCount}
          </div>
        
        </div>,
    }
    // const paymentItem = {
    //   key: "payment",
    //   label: <div onClick={jumpAccountCenter} className={`${tvHeaderPrefix}-dropdown-label dropdown-label-payment`}>
    //     <span>费用中心</span>
    //       <div className="payment-right">
    //         未支付订单{needPaymentOrderCount}
    //       </div>
    //     </div>,
    // }
    const userIndex=dropdownItemCopy.findIndex((item:any)=>item.key==='2');
    // dropdownItemCopy.splice(userIndex+1,0,paymentItem);
    dropdownItemCopy.splice(userIndex+2,0,messageItem);
    setDropdownItems(dropdownItemCopy);
  };
  const dropdownClick = async (dropdownItem: any) => {
    if (dropdownItem.url) {
      navigate(dropdownItem.url);
    } else if (dropdownItem.key === "3") {
      const res: any = await api.systemLogout();
      if (res.code === 200) {
        clearLocalStoragePreservingDownloadQuota();
        removeServiceVal("Authorization");
        // dispatch({
        //   type: "setPortalAuthorization",
        //   payload: "",
        // });
        setTimeout(() => {
          navigate(loginUrl);
        }, 200);
        
      } else {
        window.message.error(res.msg || req_err);
      }
    }
  };

  const searchResult: (any: string) => void = (query: string) => {
    api
      .documentQuery({ keyword: query })
      .then((res: any) => {
        const resData = res.data;
        const resList = resData.datas.map((item: any) => {
          return {
            value: item.url,
            label: (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <span style={{ width: "30%", marginRight: 50 }} className="one-line-ellipsis" title={item.navigationBar.replace(/<[^>]+>/g, "")}>
                  {item.navigationBar}
                </span>
                <span style={{ width: "60%" }} className="one-line-ellipsis" title={item.highlightContent.replace(/<[^>]+>/g, "")}>
                  {Parser(item.highlightContent)}
                </span>
              </div>
            ),
          };
        });
        setOptions(resList);
        setOpen(true);
      })
      .catch(() => {
        setOptions([]);
      });
  };
  /**
   * 跳转至 文档中心
   * @param url 
   */
  const jumpDocs= (url: any) => {
    url='/'+docsPrefix+url;
    if(url==window.location.pathname) return;
    const docs=store.getState().docsIframe;

    if(docs!=null){
      docs?.sendMessage(DocsMessageAction.ROUTER_CHANGE,url)
    }else{
      console.log('跳转文档中心',url)
      navigate(url);
    }
  }
  const toLink = (e: any) => {
    // 文档中心，跳转到其他项目
    if (e?.url === "/kaihong-developer-documents/kaihongos-guides/document/community/kaihongos.html") {
      jumpDocs(e?.url);
      setCurrent(e.url);
      return;
    }
    const url = e.url;
    /** 应用设备2个tab 取消点击跳转 */
    if (["KaihongOS", "KaihongOS Meta"].includes(e.label)) {
      jumpDocs(e?.menuList[1].list[0]?.url);
      setCurrent(e?.menuList[1].list[0]?.url);
      return;
    }
    navigate(`${publicPath}${url}`);
    if(e?.url.includes("technicalSupport")){
      setCurrent('technicalSupport');
    } else {
      setCurrent(e.url);
    }
  };

  const handleMouseEnter = (item: any) => {
    setIsHover(item.url);
    delay(() => {
      const menuItems: any = document.getElementsByClassName(`${tvHeaderPrefix}-menu-item`);
      for (let i = 0; i < menuItems.length; i++) {
        //遍历输出
        if (menuItems[i].className.indexOf("itemEnter") > -1) {
          setSomeDomeEnter(true);
          return;
        } else {
          setSomeDomeEnter(false);
        }
      }
    }, 0);
  };

  const handleSearch = (e: any) => {
    e ? searchResult(e) : setOptions([]);
  };

  const onSelect = (value: string) => {
    window.open(value, "_blank");
    setSearchValue("");
  };

  const inputFocus = () => {
    setInputWidth(650);
    delay(() => {
      setOpen(true);
    }, 500);
  };

  const inputBlur = () => {
    setInputWidth(250);
    setOpen(false);
  };

  const toUrl = (item: any) => {
    console.log(item);
    if (item.url === 'testdeveloper') {
      if (getServiceVal("Authorization")) {
        window.open(
          'https://testdeveloper.kaihong.com',
          "_self",
          "toolbar=yes, menubar=yes, scrollbars=yes, resizable=yes, location=yes, status=yes"
        );
      } else {
        goLogin('', {
          loginUrl: `${loginUrl}?jump_url=https://testdeveloper.kaihong.com`
        })
      }
      return
    }
    // const shoppArr = ["RK3568", "RK3588", "HI3863", "HI3873"];
    // if (shoppArr.includes(item.label)) {
    //   jumpDocs(item.url);
    // } else {
      
    // }
    setIsHover("");
    item.url && jumpDocs(item.url);
  };

  // const handleClickOutside = (event: any) => {
  //   const isIpt = AutoCompleteRef.current.contains(event.target);

  //   if (!isIpt) {
  //     setInputWidth(250);
  //     setOpen(false);
  //   }
  // };

  const clickLogo = () => {
    setCurrent("");
    const atStaging = toStagingPath.some((item) => location.pathname.includes(item));
    navigate(`${atStaging ? publicPath + "staging" : publicPath}`);
  };

  useEffect(() => {
    setDropdown(userData);
  }, [userData,messageCount,needPaymentOrderCount]);

  useEffect(() => {
    if (header.fix_top_router.includes(currentName)) {
      if (isClickCauseScroll) {
        setHiddenHeader(true);
      } else {
        // 小于400展示头部
        if (scrollHeight < 400) {
          setHiddenHeader(false);
          setHeaderOpaque(false);
        } else {
          setHeaderOpaque(true);
          //大于400分情况判断
          // 向下滚动隐藏头部
          if (scrollDirection == "down") {
            setHiddenHeader(true);
          } else {
            // 向上滚动且是快速滚动才展示头部
            if (scrollDistance > 30) {
              setHiddenHeader(false);
            }
          }
        }
      }
    }
  }, [scrollHeight, currentName]);

  useEffect(() => {
    setCurrent(currentName);
    setHiddenHeader(false);
    setHeaderOpaque(false);
    const portalDom: any = document.getElementById("portal");
    portalDom.scrollTo(0, 0);
    const fullScreenPath = fullScreenScrolling.includes(location.pathname);
    !fullScreenPath && enableScroll("portal");
  }, [location]);

  useEffect(() => {
    const storageAuthorization = getServiceVal("Authorization") || "";
    setAuthorization(storageAuthorization);
    // document.addEventListener("click", handleClickOutside);
    storageAuthorization &&
      dispatch({
        type: "setUserDataChange",
        payload: userDataChange + 1,
      });
    // return () => {
    //   document.removeEventListener("click", handleClickOutside);
    // };
    if(storageAuthorization){
      getMessageInfo();
      // getOrderInfo();
      //注册消息变更事件
      messageDispatchCenter.on(MESSAGE_ON_TYPE.MESSAGE_CHANGE,getMessageInfo);
      // messageDispatchCenter.on(MESSAGE_ON_TYPE.ORDER_CHANGE,getOrderInfo);
    }
    
  }, []);

  return (
    <div className={`${tvHeaderPrefix} ${hiddenHeader ? "displayNone" : ""} ${headerOpaque ? "headerOpaque" : ""}`}>
      <div className={`${tvHeaderPrefix}-left`}>
        <div className={`${tvHeaderPrefix}-logo-container`}>
          <div className={`${tvHeaderPrefix}-logo-left`} onClick={() => window.open('https://www.kaihong.com', '_blank')}></div>
          <div className={`${tvHeaderPrefix}-logo-right`} onClick={clickLogo}></div>
          <img src={header.logo} alt="" className={`${tvHeaderPrefix}-logo`} />
        </div>
        <div className={`${tvHeaderPrefix}-menu`}>
          {header.header_arr.map((item: any, index: number) => {
            return item.url !== 'technicalSupport' ? (
              <div
                key={item.key}
                className={`${tvHeaderPrefix}-menu-item ${item.url == current ? "on" :isDocs&&index==2?"on": ""} ${item.url == isHover ? (item.url == current ? "" : "itemEnter") : "itemLeave"} ${
                  someDomeEnter ? "dom-enter" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => toLink(item)}
                onMouseEnter={() => handleMouseEnter(item)}
                onMouseLeave={() => {
                  setIsHover("");
                  setSomeDomeEnter(false);
                }}
              >
                {item.label}
                {item?.menuList?.length ? (
                  <div className={`${tvHeaderPrefix}-more`} style={{ height: item.url == isHover ? item.height / 22.5 + "rem" : 0 }}>
                    <div className={`${tvHeaderPrefix}-more-left`}>
                      <span>{item.label}</span>
                    </div>
                    <div className={`${tvHeaderPrefix}-more-right`}>
                      {item.menuList.map((ele: any) => {
                        return (
                          <div key={ele.key} className={`${tvHeaderPrefix}-more-links`}>
                            <span className={`${tvHeaderPrefix}-links-title ${ele.url ? "isLink" : ""}`} onClick={(event) => {
                              event.stopPropagation();
                              toUrl(ele);
                            }}>
                              {ele.title}
                            </span>
                            {ele.list.map((e: any) => {
                              return (
                                <span key={e.key} className={`${tvHeaderPrefix}-more-link`} onClick={(event) => {
                                  event.stopPropagation();
                                  toUrl(e);
                                }}>
                                  {e.label}
                                  {e.isNew && <span className="new-tag">new</span>}
                                </span>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
              </div>
            ) : (
              <div
                key={item.key}
                className={`${tvHeaderPrefix}-menu-item ${item.url == current ? "on" : ""} ${item.url == isHover ? (item.url == current ? "" : "itemEnter") : "itemLeave"} ${
                  someDomeEnter ? "dom-enter" : ""
                }`}
                style={{ cursor:  "default" }}
                onMouseEnter={() => handleMouseEnter(item)}
                onMouseLeave={() => {
                  setIsHover("");
                  setSomeDomeEnter(false);
                }}
              >
                {item.label}
                {item?.menuList?.length ? (
                  <div className={`${tvHeaderPrefix}-more support`} style={{ height: item.url == isHover ? "auto" : 0 }}>
                    <div className={`${tvHeaderPrefix}-more-list`}>
                      {item.menuList.map((ele: any) => {
                        return (
                          <div key={ele.key} onClick={() => toLink(ele)}>{ele.title}</div>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
      <div className={`${tvHeaderPrefix}-right`}>
        {/* <div ref={AutoCompleteRef} className={`${tvHeaderPrefix}-autoComplete`}>
          <AutoComplete
            style={{ width: inputWidth, transition: "all 0.5s" }}
            options={options}
            onSelect={onSelect}
            value={searchValue}
            onSearch={debounce(handleSearch, 300)}
            open={open}
            maxLength={100}
            popupClassName={`${tvHeaderPrefix}-popupClass`}
            onBlur={inputBlur}
            onChange={(e: any) => {
              setSearchValue(e);
            }}
            onFocus={inputFocus}
          >
            <Input
              size="large"
              allowClear
              placeholder="请输入关键词"
              prefix={<img src={header.search} alt="" width={16} />}
              className={`${tvHeaderPrefix}-input`}
            />
          </AutoComplete>
        </div> */}
        {/* <Link to={`${publicPath}staging`} className={`${tvHeaderPrefix}-staging`}>
          {header.staging}
        </Link> */}
        {getServiceVal("Authorization") ? (
          <>
            <Badge count={messageCount} overflowCount={messageCount}>
              <div className="header-message-center" onClick={jump_messgae}>
              </div>        
            </Badge>
            
            <Dropdown menu={{ items: dropdownItems }} placement="bottomRight" overlayClassName={`${tvHeaderPrefix}-dropdown`}>
              <Avatar icon={<img src={userData.avatar || avatar_icon} className={`${tvHeaderPrefix}-avatar-icon`} />} className={`${tvHeaderPrefix}-avatar`} />
            </Dropdown>
          </>
          
        ) : (
          <a
            href={resolveLoginUrl()}
            className={`${tvHeaderPrefix}-toLogin`}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = resolveLoginUrl(window.location.href);
            }}
          >
            {login.login_text}
          </a>
        )}
      </div>
    </div>
  );
};
export default Header;
